import React from 'react';
import { Link } from 'react-router-dom';

/**
 * TerroirErrorBoundary — Terroir-styled fallback gdy komponent rzuci.
 *
 * Zastępuje legacy /components/PageErrorBoundary.js (Tailwind, white card),
 * którego widok psuł spójność redesignu.
 */
class TerroirErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('TerroirErrorBoundary:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const isDev = process.env.NODE_ENV === 'development';
    return (
      <div className="redesign-root" style={{
        minHeight: 'var(--t-vh, 100vh)',
        background: 'var(--t-bg)',
        color: 'var(--t-text)',
        display: 'grid',
        placeItems: 'center',
        padding: '24px',
      }}>
        <div style={{
          maxWidth: 460, width: '100%',
          textAlign: 'center',
          padding: '40px 28px',
          background: 'var(--t-bg-elev)',
          border: '1px solid var(--t-line)',
          borderRadius: 16,
        }}>
          <div style={{
            fontFamily: "'JetBrains Mono', ui-monospace, monospace",
            fontSize: 10,
            letterSpacing: '.22em',
            textTransform: 'uppercase',
            color: 'var(--t-rust)',
            marginBottom: 14,
          }}>BŁĄD STRONY</div>
          <div style={{
            fontFamily: "'Fraunces', Georgia, serif",
            fontSize: 32, lineHeight: 1.1,
            letterSpacing: '-.02em',
            marginBottom: 12,
          }}>Coś poszło nie tak</div>
          <div style={{
            fontSize: 14, lineHeight: 1.55,
            color: 'var(--t-text-dim)',
            marginBottom: 24,
          }}>
            Ten ekran nie wyrenderował się poprawnie. Pozostałe części aplikacji
            powinny działać normalnie.
          </div>
          {isDev && this.state.error && (
            <pre style={{
              textAlign: 'left',
              fontSize: 11,
              fontFamily: "'JetBrains Mono', monospace",
              background: 'rgba(192, 106, 74, 0.08)',
              border: '1px solid rgba(192, 106, 74, 0.20)',
              borderRadius: 8,
              padding: 12,
              marginBottom: 20,
              maxHeight: 160,
              overflow: 'auto',
              color: 'var(--t-rust)',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}>{String(this.state.error?.stack || this.state.error)}</pre>
          )}
          <div style={{
            display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap',
          }}>
            <button
              type="button"
              onClick={this.handleRetry}
              style={{
                padding: '12px 22px',
                background: 'var(--t-sage)',
                color: 'var(--t-bg)',
                border: 'none', borderRadius: 10,
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 14, fontWeight: 500,
                cursor: 'pointer',
                letterSpacing: '-.01em',
              }}
            >Spróbuj ponownie</button>
            <Link
              to="/dashboard"
              style={{
                padding: '12px 22px',
                background: 'transparent',
                color: 'var(--t-text-dim)',
                border: '1px solid var(--t-line-2)',
                borderRadius: 10,
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 14,
                textDecoration: 'none',
                letterSpacing: '-.01em',
              }}
            >Wróć do Dziś</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default TerroirErrorBoundary;
